import Categories from './Categories.view';

export default Categories;
